import {
  Box,
  Image,
  Flex,
  SimpleGrid,
  Skeleton,
  Text,
  Button,
  Grid,
  GridItem,
} from '@chakra-ui/react'
import gymRequest from '@apis/gym'
import {useEffect, useState} from 'react'
import {updateGymList} from '@redux/gym/gymSlice'
import {useDispatch, useSelector} from 'react-redux'
import PronunciationCard from './components/PronunciationCard'
import ProgressCard from './components/ProgressCard'
import SkillCard from './components/SkillCard'
import {useNavigate} from 'react-router-dom'
import {PATH} from '@utils/Const'
import {CommonColors} from '@utils/CommonStyles'
import ListLearningCard from './components/ListLearningCard'
import BookImage from '@assets/images/gym/book.png'
import PersonImage from '@assets/images/gym/person.png'
import CardTopic from '@components/CardTopic'
import vocabularyRequest from '@apis/vocabulary'

const GymPage = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const stateGym = useSelector((state: any) => state.gym)
  const [loading, setLoading] = useState(true)
  const [gymPageData, setGymPageData] = useState<any>(null)

  useEffect(() => {
    getGymList()
  }, [])

  useEffect(() => {
    const getLearnPageData = async () => {
      try {
        const res = await vocabularyRequest.getVocabularySets()
        setGymPageData(res?.data?.data)
      } catch (error) {}
    }
    getLearnPageData()
  }, [])

  const getGymList = async () => {
    try {
      const gymList = await gymRequest.getGymResult()
      dispatch(updateGymList(gymList?.data?.data?.ipa_lessons))
      setLoading(false)
    } catch (error) {
      console.log(error)
      setLoading(false)
    }
  }

  const renderHeader = () => (
    <Box bg={CommonColors.white} p={{base: '16px', md: '32px'}}>
      <Box maxW={'1400px'} mx={'auto'}>
        <Text fontSize={{base: '24px', lg: '30px'}} fontWeight={'600'}>
          Luyện kỹ năng phòng thi
        </Text>
        <Text
          mt={'16px'}
          fontSize={{base: '14px', lg: '16px'}}
          fontWeight={'400'}
          color={'#7C7C7C'}>
          Các công cụ chuyên sâu để cải thiện các điểm yếu của bạn theo từng
          tiêu chí chấm điểm
        </Text>
      </Box>
    </Box>
  )

  return (
    <Box pt={{base: '16px', md: 0}}>
      {renderHeader()}
      <Box p={{base: '16px', md: '32px'}}>
        <Box maxW={'1400px'} mx={'auto'}>
          <ListLearningCard />
          <Box
            p={{base: '16px', md: '32px'}}
            mt={{base: '16px', md: '32px'}}
            bg={CommonColors.white}
            borderRadius={'16px'}>
            <Flex
              justifyContent={'space-between'}
              gap={{base: '16px', md: '32px'}}>
              <Flex gap={{base: '16px', md: '32px'}}>
                <Box>
                  <Text fontSize={{base: '16px', md: '24px'}} fontWeight={600}>
                    Nạp cụm theo chủ đề
                  </Text>
                  <Text
                    fontSize={{base: '14px', md: '16px'}}
                    color={'#7C7C7C'}
                    mt={'16px'}
                    maxW={'400px'}>
                    Tăng điểm Lexical Resources (từ vựng) cùng các từ và cụm
                    trong chủ đề
                  </Text>
                </Box>
                <Image
                  src={BookImage}
                  w={{base: '40px', md: '70px'}}
                  objectFit={'contain'}
                />
              </Flex>
              <Button
                fontSize={{base: '14px', md: '16px'}}
                variant={'outline'}
                borderColor={'#59BAFF'}
                color={'#59BAFF'}
                flexShrink={0}
                onClick={() => {
                  navigate(PATH.GYM_VOCABULARY, {
                    state: {
                      feature: 'VOCABULARY',
                      topic: gymPageData[0]?.text_en,
                      thumbnail: gymPageData[0]?.topic_image,
                    },
                  })
                }}>
                Xem tất cả
              </Button>
            </Flex>
            <Grid
              templateColumns={{
                base: 'repeat(1, 1fr)',
                lg: 'repeat(2, 1fr)',
                xl: 'repeat(3, 1fr)',
              }}
              gap={{base: '16px', md: '32px'}}
              mt={{base: '16px', md: '32px'}}>
              {gymPageData?.map((topic: any, index: any) => (
                <GridItem key={index}>
                  <CardTopic
                    title={topic.text_en}
                    subtitle={topic.text_vi}
                    image={topic.topic_image}
                    completedLesson={topic.completed_sets}
                    totalLesson={topic.total_sets}
                    progress={topic.progress_percentage}
                    onClick={() => {
                      navigate(PATH.GYM_VOCABULARY, {
                        state: {
                          feature: 'VOCABULARY',
                          thumbnail: topic.topic_image,
                          topic: topic?.text_en,
                        },
                      })
                    }}
                  />
                </GridItem>
              ))}
            </Grid>
          </Box>
          <Box
            mt={'32px'}
            bg={CommonColors.white}
            borderRadius={'16px'}
            p={{base: '16px', md: '32px'}}>
            <Flex justifyContent={'space-between'}>
              <Box>
                <Text fontSize={{base: '16px', md: '24px'}} fontWeight={600}>
                  Khoá học IPA
                </Text>
                <Text
                  fontSize={{base: '14px', md: '16px'}}
                  color={'#7C7C7C'}
                  mt={'16px'}>
                  Cải thiện phát âm của bạn với các bài học về hơn 40 âm IPA phổ
                  biến nhất
                </Text>
              </Box>
              <Image src={PersonImage} w={'80px'} objectFit={'contain'} />
            </Flex>
            <Flex
              mt={'32px'}
              flexDirection={{base: 'column-reverse', lg: 'row-reverse'}}
              gap={{base: '16px', lg: '32px'}}>
              <Flex w={{base: '100%', lg: '69.32%'}}>
                <SimpleGrid
                  columns={{base: 1, lg: 2}}
                  w={'100%'}
                  spacing={{base: '16px', lg: '32px'}}>
                  {!loading
                    ? stateGym.data?.map((item: any, index: any) => (
                        <PronunciationCard
                          key={index}
                          item={item}
                          index={index}
                        />
                      ))
                    : Array.from(Array(4)).map((_: any, index: any) => (
                        <Box key={index} p={'20px'}>
                          <Box p={'20px'}>
                            <Skeleton height={'32px'} />
                          </Box>
                          <Flex mt={'20px'} gap={'20px'}>
                            {Array.from(Array(3)).map((_: any, index: any) => (
                              <Flex
                                key={index}
                                flex={1}
                                alignItems={'center'}
                                flexDirection={'column'}
                                gap={'12px'}>
                                <Skeleton
                                  height={'64px'}
                                  w={'64px'}
                                  borderRadius={'50%'}
                                />
                                <Skeleton height={'42px'} w={'100%'} />
                              </Flex>
                            ))}
                          </Flex>
                        </Box>
                      ))}
                </SimpleGrid>
              </Flex>
              <Flex w={{base: '100%', lg: '33.33%'}}>
                <Box w={'100%'}>
                  <ProgressCard />
                  <SkillCard />
                </Box>
              </Flex>
            </Flex>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

export default GymPage
